import { Injectable } from '@angular/core';
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})
export class FormHelperService {

    // tslint:disable-next-line:no-any
    public removeEmptyObjectsAndFormatDate(object: object, dontRemove: string[] = [], removeMinusOne?: boolean): any {

        Object.keys(object).forEach((key: string): void => {
            // If Object recall function, keep in mind : Array is Object in JS
            if (object[key] && typeof object[key] === 'object') {
                // Recursion
                this.removeEmptyObjectsAndFormatDate(object[key], dontRemove, removeMinusOne);
                // Format date to YYYY-MM-DD
                if (object[key] instanceof Date || moment.isMoment(object[key])) {
                    object[key] = this.formatDate(object[key]);
                }

                // If object is empty then delete it
                if (!Object.keys(object[key]).length && dontRemove.indexOf(key) === -1) {
                    // tslint:disable-next-line:no-dynamic-delete
                    delete object[key];
                }
            }
            // If null delete property
            else if (
                (object[key] === null || object[key] === '' || object[key] === ' ') &&
                dontRemove?.indexOf(key) === -1) {
                // tslint:disable-next-line:no-dynamic-delete
                delete object[key];
            }
            // #35297: If needed, remove property if value === -1
            else if(removeMinusOne && object[key] === -1){
                // tslint:disable-next-line:no-dynamic-delete
                delete object[key];
            }
            // else if(object[key] && Array.isArray(object[key]) && object[key].length){
            //     object[key] = this.removeEmptyObjectsAndFormatDate(object[key], dontRemove);
            // }
        });
        return object;
    }

    private formatDate(date: Date): string {
        return moment(date).format('YYYY-MM-DD');
    }
}
